export function Illustration(props: any) {

    return (
        <>
            <img className={props.className} loading={props.loading} alt={props.alt} src={props.src} />
        </>
    )
} 